"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var plugin_forced_layout_1 = __importDefault(require("@sheets-editor/plugin-forced-layout"));
var editor_web_1 = require("@21st-night/editor-web");
var core_1 = require("@material-ui/core");
var cards_web_1 = require("@21st-night/cards-web");
var Editor_1 = require("../../Editor");
var ActionButtons_1 = __importDefault(require("../../ActionButtons"));
var ClozeDeletionModeLayout = plugin_forced_layout_1.default({
    layout: ['card-answer-disabled', 'card-explanation', 'card-summary'],
});
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {},
        marginTop: {
            marginTop: theme.spacing(4),
        },
        editorContainer: {
            position: 'relative',
        },
        answerPlaceholder: {
            position: 'absolute',
            color: '#BDBDBD',
            top: 99,
        },
        explanationPlaceholder: {
            position: 'absolute',
            color: '#BDBDBD',
            bottom: 44,
        },
        rightColumn: {
            display: 'flex',
            flexDirection: 'column',
        },
        categories: {
            paddingTop: 36,
            flex: 1,
        },
    });
});
var CardAnswerPlugin = cards_web_1.createCardAnswerPlugin({
    answerElementMinHeight: 100,
});
var CardAnswerForm = function (_a) {
    var actionButtons = _a.actionButtons, classNameProp = _a.className, clozeDeletionMode = _a.clozeDeletionMode, errors = _a.errors, onChange = _a.onChange, valuesProp = _a.values, noteSelect = _a.noteSelect, categorySelect = _a.categorySelect, subcategorySelect = _a.subcategorySelect, other = __rest(_a, ["actionButtons", "className", "clozeDeletionMode", "errors", "onChange", "values", "noteSelect", "categorySelect", "subcategorySelect"]);
    var _b = __read(react_1.useState([
        editor_web_1.stripDocumentMetadata(valuesProp.answer),
        editor_web_1.stripDocumentMetadata(valuesProp.explanation),
        editor_web_1.stripDocumentMetadata(valuesProp.summary),
    ]), 1), values = _b[0];
    var _c = __read(react_1.useState([
        {
            type: clozeDeletionMode ? 'card-answer-disabled' : 'card-answer',
            children: clozeDeletionMode ? [{ text: '' }] : values[0][0],
            content: clozeDeletionMode
                ? // @ts-ignore
                    valuesProp.answer[0].children[0].text
                : undefined,
        },
        { type: 'card-explanation', children: values[1][0] },
        {
            type: 'card-summary',
            children: values[2][0],
        },
    ]), 2), value = _c[0], setValue = _c[1];
    var classes = exports.useStyles();
    react_1.useEffect(function () {
        if (value[0] && !clozeDeletionMode) {
            onChange('answer', editor_web_1.addDocumentMetadata(value[0].children, values[0][1]));
        }
        if (value[1]) {
            onChange('explanation', editor_web_1.addDocumentMetadata(value[1].children, values[1][1]));
        }
        if (value[2]) {
            onChange('summary', editor_web_1.addDocumentMetadata(value[2].children, values[2][1]));
        }
    }, [value, clozeDeletionMode]);
    var plugins = [CardAnswerPlugin];
    if (clozeDeletionMode) {
        plugins.push(ClozeDeletionModeLayout);
    }
    return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.root, classNameProp) }, other),
        react_1.default.createElement(core_1.Grid, { container: true, spacing: 6 },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 8 },
                errors.answer && react_1.default.createElement(core_1.FormHelperText, { error: true }, errors.answer),
                react_1.default.createElement("div", { className: classes.editorContainer },
                    react_1.default.createElement(Editor_1.Editor, { autoFocus: !clozeDeletionMode, plugins: plugins, value: value, onChange: setValue, placeholder: "Answer goes here..." }))),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 4, className: classes.rightColumn },
                react_1.default.createElement(core_1.Hidden, { xsDown: true },
                    react_1.default.createElement("div", { className: classes.categories },
                        react_1.default.createElement(core_1.Typography, { variant: "subtitle1" }, "Category"),
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, style: { marginBottom: 32 } }, categorySelect),
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                            react_1.default.createElement(core_1.Typography, { variant: "subtitle1" }, "Subcategories"),
                            subcategorySelect),
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 12 }, noteSelect))),
                react_1.default.createElement(ActionButtons_1.default, { spaced: true, align: "end" }, actionButtons)))));
};
exports.default = CardAnswerForm;
//# sourceMappingURL=CardAnswerForm.js.map